import React, { useState, useEffect } from 'react';
import EditorPdf from './EditorPdf';

const MODELOS = [
  { key: 'procuracao_cpf',  label: 'Procuração CPF' },
  { key: 'procuracao_cnpj', label: 'Procuração CNPJ' },
  { key: 'contrato',        label: 'Contrato de Prestação de Serviço' },
  { key: 'orcamento',       label: 'Orçamento' },
];

const CAMPOS = {
  procuracao_cpf: [
    { name: 'nome',         label: 'Nome completo',       placeholder: 'Ex: EDUARDO ARAÚJO FLORENCIO',           required: true },
    { name: 'cpf',          label: 'CPF',                 placeholder: 'Ex: 032.468.634-07',                      required: true },
    { name: 'profissao',    label: 'Profissão',           placeholder: 'Ex: empreendedor',                        required: false },
    { name: 'nacionalidade',label: 'Nacionalidade',       placeholder: 'Ex: brasileiro(a)',                       required: false },
    { name: 'endereco',     label: 'Endereço completo',   placeholder: 'Rua, nº, bairro, cidade - UF',           required: true },
  ],
  procuracao_cnpj: [
    { name: 'nome_empresa',          label: 'Razão Social',              placeholder: 'Ex: EMPRESA LTDA',                  required: true },
    { name: 'cnpj_empresa',          label: 'CNPJ da Empresa',           placeholder: 'Ex: 23.323.344/0001-37',             required: true },
    { name: 'endereco_empresa',      label: 'Endereço da Empresa',       placeholder: 'Rua, nº, bairro, cidade - UF, CEP', required: true },
    { name: 'nome_representante',    label: 'Nome do Representante',     placeholder: 'Ex: JOÃO DA SILVA',                  required: true },
    { name: 'cpf_representante',     label: 'CPF do Representante',      placeholder: 'Ex: 000.000.000-00',                 required: true },
    { name: 'nacionalidade',         label: 'Nacionalidade',             placeholder: 'Ex: brasileiro(a)',                  required: false },
    { name: 'profissao_representante',label: 'Profissão do Representante',placeholder: 'Ex: empresário(a)',                required: false },
  ],
  contrato: [
    { name: 'tipo',                  label: 'Tipo de pessoa',            tipo: 'select', opcoes: [{ v: 'cnpj', l: 'Pessoa Jurídica (CNPJ)' }, { v: 'cpf', l: 'Pessoa Física (CPF)' }], required: true },
    { name: 'nome_contratante',      label: 'Nome / Razão Social',       placeholder: 'Ex: EMPRESA LTDA',                  required: true },
    { name: 'cpf_cnpj',             label: 'CPF / CNPJ',               placeholder: 'Ex: 00.000.000/0001-00',             required: true },
    { name: 'endereco_contratante',  label: 'Endereço',                  placeholder: 'Rua, nº, bairro, cidade - UF',      required: true },
    { name: 'nome_representante',    label: 'Nome do Representante',     placeholder: 'Ex: MARIA SILVA',                    required: true },
    { name: 'cpf_representante',     label: 'CPF do Representante',      placeholder: 'Ex: 000.000.000-00',                 required: true },
    { name: 'nacionalidade',         label: 'Nacionalidade',             placeholder: 'Ex: brasileiro(a)',                  required: false },
    { name: 'profissao_representante',label: 'Profissão do Representante',placeholder: 'Ex: empresário(a)',                required: false },
    { name: 'objeto',                label: 'Objeto do contrato',        placeholder: 'Ex: DOIS PEDIDOS DE REGISTRO DA MARCA', required: true },
    { name: 'valor',                 label: 'Valor (R$)',                placeholder: 'Ex: R$3.200,00',                     required: true },
    { name: 'valor_extenso',         label: 'Valor por extenso',         placeholder: 'Ex: três mil e duzentos reais',       required: true },
    { name: 'assinatura',            label: 'Assinatura do Vagner',      tipo: 'select', opcoes: [{ v: 'com', l: '✍️ Com assinatura (sai já assinado)' }, { v: 'sem', l: 'Sem assinatura (imprimir e assinar à mão)' }], required: true },
  ],
  orcamento: [
    { name: 'nome',               label: 'Nome do cliente / empresa',        placeholder: 'Ex: CARLOS APOLINÁRIO',                       required: true },
    { name: 'cidade_uf',          label: 'Cidade – UF',                      placeholder: 'Ex: Campina Grande – PB',                     required: true },
    { name: 'honorarios',         label: 'Honorários (R$, por processo)',    placeholder: 'Ex: R$ 1.850,00',                             required: true },
    { name: 'honorarios_extenso', label: 'Honorários por extenso',           placeholder: 'Ex: hum mil oitocentos e cinquenta reais',    required: true },
    { name: 'taxa_inpi',          label: 'Taxa do INPI (R$, por processo)',  placeholder: 'Ex: R$ 440,00',                               required: true },
    { name: 'total',              label: 'Valor total dos serviços (R$)',    placeholder: 'Ex: R$ 2.290,00',                             required: true },
    { name: 'total_extenso',      label: 'Total por extenso',                placeholder: 'Ex: dois mil duzentos e noventa reais',       required: true },
    { name: 'parcelas',           label: 'Parcelas no cartão (sem juros)',   placeholder: 'Ex: 06',                                      required: true },
  ],
};

const inp = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 };

function token() { return localStorage.getItem('token'); }

export default function GeradorArquivos() {
  const [modeloAtivo, setModeloAtivo] = useState(null);
  const [form, setForm] = useState({});
  const [gerando, setGerando] = useState(null);
  const [concluido, setConcluido] = useState(false);
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [gerados, setGerados] = useState([]);
  const [baixandoGerado, setBaixandoGerado] = useState('');

  // 🗄️ Histórico de 72h: todo documento gerado fica no servidor pra re-download
  async function carregarGerados() {
    try {
      const r = await fetch('/documentos/gerados', { headers: { Authorization: `Bearer ${token()}` } });
      if (r.ok) setGerados(await r.json());
    } catch { /* lista fica como está */ }
  }
  useEffect(() => { carregarGerados(); }, []);

  async function baixarGerado(g) {
    setBaixandoGerado(g.id);
    try {
      const r = await fetch(`/documentos/gerados/${g.id}`, { headers: { Authorization: `Bearer ${token()}` } });
      if (!r.ok) {
        let msg = 'Falha no download';
        try { msg = (await r.json()).erro; } catch (e) { /* sem corpo */ }
        throw new Error(msg);
      }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = g.nome;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      alert(e.message);
      carregarGerados();
    }
    setBaixandoGerado('');
  }

  // 🔍 Consulta o CNPJ na Receita e preenche razão social + endereço montado.
  // O campo de origem diz qual formulário está aberto: 'cnpj_empresa' é a
  // procuração CNPJ; 'cpf_cnpj' é o contrato (só busca se for CNPJ mesmo).
  async function consultarCnpj(campoOrigem) {
    const dig = String(form[campoOrigem] || '').replace(/\D/g, '');
    if (dig.length !== 14) {
      return window.alert(campoOrigem === 'cpf_cnpj'
        ? 'A busca automática funciona só com CNPJ (14 dígitos). Para CPF, preencha à mão.'
        : 'Digite o CNPJ completo (14 dígitos) antes de buscar.');
    }
    setBuscandoCnpj(true);
    try {
      const r = await fetch(`/clientes/consultar-cnpj/${dig}`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'CNPJ não encontrado.');
      const endereco = [d.rua, d.numero, d.complemento, d.bairro,
        d.cidade && `${d.cidade} - ${d.estado}`, d.cep && `CEP ${d.cep}`].filter(Boolean).join(', ');
      setForm(f => campoOrigem === 'cnpj_empresa'
        ? { ...f, nome_empresa: d.razao_social || f.nome_empresa || '', endereco_empresa: endereco || f.endereco_empresa || '' }
        : { ...f, tipo: 'cnpj', nome_contratante: d.razao_social || f.nome_contratante || '', endereco_contratante: endereco || f.endereco_contratante || '' });
    } catch (e) { window.alert('Não consegui buscar: ' + e.message); }
    setBuscandoCnpj(false);
  }
  const [baixandoApres, setBaixandoApres] = useState(false);
  const [perguntouContrato, setPerguntouContrato] = useState(false); // pergunta 1x por procuração
  const [editorPdf, setEditorPdf] = useState(false); // ✏️ retoques em PDF existente

  // Procuração → contrato com os MESMOS dados (CPF→cpf, CNPJ→cnpj); na
  // pessoa física o representante do contrato é a própria pessoa. Só resta
  // preencher objeto e valores.
  function dadosContratoDaProcuracao() {
    if (modeloAtivo === 'procuracao_cpf') return {
      tipo: 'cpf', assinatura: 'com',
      nome_contratante: form.nome || '', cpf_cnpj: form.cpf || '',
      endereco_contratante: form.endereco || '',
      nome_representante: form.nome || '', cpf_representante: form.cpf || '',
      nacionalidade: form.nacionalidade || '', profissao_representante: form.profissao || '',
    };
    return {
      tipo: 'cnpj', assinatura: 'com',
      nome_contratante: form.nome_empresa || '', cpf_cnpj: form.cnpj_empresa || '',
      endereco_contratante: form.endereco_empresa || '',
      nome_representante: form.nome_representante || '', cpf_representante: form.cpf_representante || '',
      nacionalidade: form.nacionalidade || '', profissao_representante: form.profissao_representante || '',
    };
  }
  function abrirContratoComDados() {
    setForm(dadosContratoDaProcuracao());
    setModeloAtivo('contrato');
    setConcluido(false);
  }

  // Apresentação da empresa: download direto (sem formulário) — o servidor
  // entrega o mesmo PDF institucional que a Clau envia no WhatsApp
  async function baixarApresentacao() {
    setBaixandoApres(true);
    try {
      const res = await fetch('/documentos/apresentacao', { headers: { Authorization: `Bearer ${token()}` } });
      if (!res.ok) throw new Error('Apresentação não encontrada no servidor');
      const blob = await res.blob();
      const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Apresentação Preserva Marcas.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      alert('Erro ao baixar: ' + e.message);
    } finally {
      setBaixandoApres(false);
    }
  }

  function selecionarModelo(key) {
    setModeloAtivo(key);
    // Orçamento já vem com os padrões da casa preenchidos (tudo editável)
    setForm(key === 'orcamento'
      ? { cidade_uf: 'Campina Grande – PB', taxa_inpi: 'R$ 440,00', parcelas: '06' }
      : { tipo: 'cnpj', assinatura: 'com' });
    setConcluido(false);
    setPerguntouContrato(false);
  }

  async function gerar(formato) {
    setGerando(formato);
    try {
      const res = await fetch(`/documentos/${formato}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ tipo: modeloAtivo, dados: modeloAtivo === 'contrato' ? { ...form, data: new Date().toISOString().split('T')[0] } : form }),
      });
      if (!res.ok) {
        const text = await res.text();
        let msg = 'Erro ao gerar';
        try { msg = JSON.parse(text).erro; } catch(e) {}
        throw new Error(msg);
      }
      const blob = await res.blob();
      const ext = formato === 'pdf' ? 'pdf' : 'docx';
      const mime = formato === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      const finalBlob = new Blob([blob], { type: mime });
      const url = URL.createObjectURL(finalBlob);
      const a = document.createElement('a');
      a.href = url;
      // Nome do arquivo com o cliente: "Procuração de FULANO.pdf",
      // "Contrato de EMPRESA LTDA.pdf", "Orçamento de CARLOS.pdf"
      const nomeCliente = (
        modeloAtivo === 'procuracao_cpf' ? form.nome
          : modeloAtivo === 'procuracao_cnpj' ? form.nome_empresa
          : modeloAtivo === 'contrato' ? form.nome_contratante
          : form.nome
      ) || '';
      const prefixo = modeloAtivo.startsWith('procuracao') ? 'Procuração' : modeloAtivo === 'contrato' ? 'Contrato' : 'Orçamento';
      const limpo = nomeCliente.trim().replace(/[\\/:*?"<>|]/g, '').slice(0, 80);
      a.download = `${limpo ? `${prefixo} de ${limpo}` : modeloAtivo}.${ext}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setConcluido(true);
      carregarGerados();
      // Procuração baixada → oferece o contrato com os mesmos dados (1x;
      // o botão verde no quadro de download fica disponível se recusar)
      if ((modeloAtivo === 'procuracao_cpf' || modeloAtivo === 'procuracao_cnpj') && !perguntouContrato) {
        setPerguntouContrato(true);
        setTimeout(() => {
          if (window.confirm(`Procuração gerada! Deseja gerar também o CONTRATO ${modeloAtivo === 'procuracao_cpf' ? 'de pessoa física (CPF)' : 'de pessoa jurídica (CNPJ)'} com os mesmos dados?\n\nSó vai faltar preencher o objeto e os valores.`)) {
            abrirContratoComDados();
          }
        }, 400);
      }
    } catch (e) {
      alert('Erro ao gerar arquivo: ' + e.message);
    } finally {
      setGerando(null);
    }
  }

  function handleSubmit(e) { e.preventDefault(); setConcluido(true); }

  const campos = modeloAtivo ? CAMPOS[modeloAtivo] : [];

  if (editorPdf) return <EditorPdf onVoltar={() => setEditorPdf(false)} />;

  return (
    <div style={{ maxWidth: 760 }}>
      <div style={{ marginBottom: 12 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628' }}>Gerador de Arquivos</h1>
        <p style={{ color: '#6b7280', fontSize: 12, marginTop: 1 }}>Preencha os dados e gere o documento em Word ou PDF</p>
      </div>

      {/* Seleção de modelo */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
        {MODELOS.map(m => (
          <div key={m.key} onClick={() => selecionarModelo(m.key)}
            style={{
              flex: 1, minWidth: 160, background: '#fff', borderRadius: 4, padding: '10px 14px',
              border: `2px solid ${modeloAtivo === m.key ? '#0a1628' : '#c8d0da'}`,
              cursor: 'pointer', transition: 'all 0.15s',
              background: modeloAtivo === m.key ? '#f0f4ff' : '#fff',
            }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{m.label}</div>
          </div>
        ))}
        {/* Apresentação da empresa: sem formulário — baixa direto */}
        <div onClick={() => !baixandoApres && baixarApresentacao()}
          title="Baixar o PDF institucional (o mesmo que a Clau envia no WhatsApp)"
          style={{
            flex: 1, minWidth: 160, borderRadius: 4, padding: '10px 14px',
            border: '2px solid #bbf7d0', background: '#f0fdf4',
            cursor: 'pointer', transition: 'all 0.15s', opacity: baixandoApres ? 0.6 : 1,
          }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#15803d' }}>
            {baixandoApres ? '⏳ Baixando…' : '📽️ Apresentação da Empresa'}
          </div>
          <div style={{ fontSize: 10.5, color: '#6b7280', marginTop: 2 }}>PDF pronto — download direto</div>
        </div>
        {/* Editor de retoques: escreve/cobre por cima de um PDF existente */}
        <div onClick={() => setEditorPdf(true)}
          title="Abra um PDF, escreva ou cubra por cima e salve com os retoques"
          style={{
            flex: 1, minWidth: 160, borderRadius: 4, padding: '10px 14px',
            border: '2px solid #ddd6fe', background: '#f5f3ff',
            cursor: 'pointer', transition: 'all 0.15s',
          }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#6d28d9' }}>✏️ Editar PDF existente</div>
          <div style={{ fontSize: 10.5, color: '#6b7280', marginTop: 2 }}>Escrever e cobrir por cima — salva em PDF</div>
        </div>
      </div>

      {modeloAtivo && (
        <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden' }}>
          <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            {MODELOS.find(m => m.key === modeloAtivo)?.label}
          </div>

          <form onSubmit={handleSubmit} style={{ padding: '10px 14px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {campos.map(campo => (
                <div key={campo.name} style={{ gridColumn: ['endereco', 'endereco_empresa', 'endereco_contratante', 'objeto', 'honorarios_extenso', 'total_extenso'].includes(campo.name) ? '1 / -1' : 'auto' }}>
                  <label style={lbl}>{campo.label}{campo.required && <span style={{ color: '#dc2626' }}> *</span>}</label>
                  {campo.tipo === 'select' ? (
                    <select value={form[campo.name] || ''} onChange={e => setForm(f => ({ ...f, [campo.name]: e.target.value }))}
                      style={inp}>
                      {campo.opcoes.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                    </select>
                  ) : ['cnpj_empresa', 'cpf_cnpj'].includes(campo.name) ? (
                    // 🔍 Consulta na Receita: preenche razão social e endereço
                    // sozinha (mesma rota do cadastro do cliente)
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input
                        type="text"
                        value={form[campo.name] || ''}
                        onChange={e => setForm(f => ({ ...f, [campo.name]: e.target.value }))}
                        placeholder={campo.placeholder}
                        required={campo.required}
                        style={{ ...inp, flex: 1 }}
                      />
                      <button type="button" onClick={() => consultarCnpj(campo.name)} disabled={buscandoCnpj}
                        title="Buscar razão social e endereço na Receita Federal"
                        style={{ background: '#fff', color: '#0a1628', border: '1px solid #0a1628', borderRadius: 4, padding: '0 10px', fontSize: 12, fontWeight: 600, cursor: buscandoCnpj ? 'wait' : 'pointer', whiteSpace: 'nowrap' }}>
                        {buscandoCnpj ? '...' : '🔍 CNPJ'}
                      </button>
                    </div>
                  ) : (
                    <input
                      type={campo.type || 'text'}
                      value={form[campo.name] || ''}
                      onChange={e => setForm(f => ({ ...f, [campo.name]: e.target.value }))}
                      placeholder={campo.placeholder}
                      required={campo.required}
                      style={inp}
                    />
                  )}
                </div>
              ))}
            </div>

            <button type="submit" style={{ background: '#0a1628', color: '#fff', padding: '4px 16px', fontSize: 12, fontWeight: 600, marginTop: 12, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
              Preparar documento
            </button>
          </form>

          {concluido && (
            <div style={{ margin: '0 14px 14px', padding: 12, background: '#f0fdf4', borderRadius: 4, border: '1px solid #bbf7d0' }}>
              <p style={{ fontSize: 12, fontWeight: 600, color: '#16a34a', marginBottom: 10 }}>Documento pronto! Escolha o formato para baixar:</p>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button onClick={() => gerar('word')} disabled={!!gerando}
                  style={{ background: '#1d4ed8', color: '#fff', padding: '4px 14px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                  {gerando === 'word' ? 'Gerando...' : 'Baixar Word (.docx)'}
                </button>
                <button onClick={() => gerar('pdf')} disabled={!!gerando}
                  style={{ background: '#dc2626', color: '#fff', padding: '4px 14px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                  {gerando === 'pdf' ? 'Gerando...' : 'Baixar PDF'}
                </button>
                {(modeloAtivo === 'procuracao_cpf' || modeloAtivo === 'procuracao_cnpj') && (
                  <button onClick={abrirContratoComDados} title="Abre o contrato já preenchido com os dados desta procuração — só falta objeto e valores"
                    style={{ background: '#16a34a', color: '#fff', padding: '4px 14px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                    📝 Gerar contrato com esses dados
                  </button>
                )}
              </div>
            </div>
          )}

          {(modeloAtivo === 'procuracao_cpf' || modeloAtivo === 'procuracao_cnpj') && (
            <div style={{ margin: '0 14px 14px', padding: 12, background: '#f8fafc', borderRadius: 4, border: '1px solid #e2e8f0', fontSize: 11.5, color: '#374151' }}>
              <div style={{ fontWeight: 700, color: '#0a1628', marginBottom: 4 }}>✅ Checklist do INPI pra procuração valer (Manual 4.2.7)</div>
              <div>• Outorgante e outorgado identificados por completo · • Poderes para representar junto ao INPI · • Data, local e assinatura</div>
              <div>• Cliente domiciliado no EXTERIOR: precisa constar poderes para receber citações judiciais (art. 217 da LPI)</div>
              <div>• Sem procuração no depósito? Prazo de <strong>60 dias</strong> pra apresentar (petição cód. 381) — perdeu, o pedido é arquivado em definitivo</div>
              <div>• Desistência ou renúncia exigem poderes <strong>expressos</strong> na procuração · • Não precisa de firma reconhecida nem cartório</div>
            </div>
          )}
        </div>
      )}

      {/* 🗄️ Documentos gerados nas últimas 72h — re-download sem refazer */}
      {gerados.length > 0 && (
        <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden', marginTop: 14 }}>
          <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            🗄️ Gerados nas últimas 72h ({gerados.length})
          </div>
          <div style={{ padding: '6px 14px 10px' }}>
            {gerados.map(g => {
              const criado = new Date(g.criado_em);
              const restanteH = Math.max(0, Math.round((criado.getTime() + 72 * 3600000 - Date.now()) / 3600000));
              return (
                <div key={g.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0', borderBottom: '1px solid #eef1f5', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 15 }}>{g.formato === 'pdf' ? '📄' : '📝'}</span>
                  <span style={{ fontSize: 12.5, fontWeight: 600, color: '#0a1628', flex: 1, minWidth: 180 }}>{g.nome}</span>
                  <span style={{ fontSize: 11, color: '#6b7280', whiteSpace: 'nowrap' }}>
                    {criado.toLocaleDateString('pt-BR')} {criado.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                    {g.usuario ? ` · ${g.usuario}` : ''}
                  </span>
                  <span title="Tempo restante até expirar" style={{ fontSize: 10.5, fontWeight: 700, color: restanteH <= 12 ? '#b45309' : '#6b7280', background: restanteH <= 12 ? '#fffbeb' : '#f3f4f6', border: `1px solid ${restanteH <= 12 ? '#fde68a' : '#e5e7eb'}`, borderRadius: 8, padding: '1px 7px', whiteSpace: 'nowrap' }}>
                    ⏳ {restanteH}h
                  </span>
                  <button onClick={() => baixarGerado(g)} disabled={baixandoGerado === g.id}
                    style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '3px 12px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer', opacity: baixandoGerado === g.id ? 0.6 : 1 }}>
                    {baixandoGerado === g.id ? '⏳' : '⬇️ Baixar'}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
